import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';

import { addLocaleData } from 'react-intl';

import locale_en from 'react-intl/locale-data/en';
import locale_de from 'react-intl/locale-data/de';
import locale_es from 'react-intl/locale-data/es';
import locale_fi from 'react-intl/locale-data/fi';
import locale_fr from 'react-intl/locale-data/fr';
import locale_it from 'react-intl/locale-data/it';
import locale_ro from 'react-intl/locale-data/ro';
import locale_sl from 'react-intl/locale-data/sl';
import locale_bs from 'react-intl/locale-data/bs';

// import 'moment/locale/de';
// import 'moment/locale/fr';
// import 'moment/locale/it';

import stores from './stores';
import App from './containers/App';

import './helpers/extensions';

const render = (Component) => {
  addLocaleData([
    ...locale_en,
    ...locale_de,
    ...locale_es,
    ...locale_fi,
    ...locale_fr,
    ...locale_it,
    ...locale_ro,
    ...locale_sl,
    ...locale_bs,
  ]);

  ReactDOM.render(
    <Provider {...stores}>
      <Component />
    </Provider>,
    document.getElementById('app')
  );
};

render(App);



// WEBPACK FOOTER //
// ./src/app/index.jsx